import AdminDeviceTypes from './AdminDeviceTypes'
export default AdminDeviceTypes
